import React from 'react'
import { Row, Col, Form, Input, Radio } from 'antd'

const requiredMark = (
  <span style={{ color: '#ff4d4f' }}> *</span>
)

// One "Standard LTL Freight" or "FedEx Freight Direct" account sub-form, used twice
// (Standard/Direct) inside FedexFreightAccountSection. `keyPrefix` drives the flat
// locationDetail field names (fedex_${keyPrefix}_*); `accountNumberFieldName` is passed
// separately because the Standard account number keeps the legacy `fedex_account_number`
// key so it keeps flowing into the existing quoting override untouched.
const FedexFreightAccountFieldset = ({
  title,
  keyPrefix,
  accountNumberFieldName,
  showFreightDirectLink,
  locationDetail,
  changeValue,
  fieldErrors,
}) => {
  const field = suffix => `fedex_${keyPrefix}_${suffix}`
  const testType = locationDetail?.[field('test_type')] || 'shipper'
  const errorProps = name => (
    fieldErrors?.[name] ? { validateStatus: 'error', help: fieldErrors[name] } : {}
  )

  return (
    <Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={24}>
      <strong>{title}</strong>

      <Form.Item
        className='mb-2 mt-2'
        label={
          <span className='text-gray'>
            FedEx Freight Account Number
            {requiredMark}
          </span>
        }
        {...errorProps(accountNumberFieldName)}
      >
        <Input
          name={accountNumberFieldName}
          placeholder='e.g. 209033858'
          value={locationDetail?.[accountNumberFieldName]}
          onChange={changeValue}
          maxLength={50}
        />
      </Form.Item>

      <Form.Item className='mb-2' label={<span className='text-gray'>Third-party FedEx Freight Account Number</span>}>
        <Input
          name={field('third_party_account_number')}
          placeholder='e.g. 987654321'
          value={locationDetail?.[field('third_party_account_number')]}
          onChange={changeValue}
          maxLength={50}
        />
      </Form.Item>

      <Form.Item className='mb-2' label={<span className='text-gray'>Account Name</span>}>
        <Input
          name={field('account_name')}
          placeholder='e.g. ABC Logistics LLC'
          value={locationDetail?.[field('account_name')]}
          onChange={changeValue}
          maxLength={100}
        />
      </Form.Item>

      <Form.Item className='mb-2' label={<span className='text-gray'>Address{requiredMark}</span>} {...errorProps(field('address'))}>
        <Input
          name={field('address')}
          placeholder='e.g. 320 Lanier Ave W Ste 200'
          value={locationDetail?.[field('address')]}
          onChange={changeValue}
          maxLength={255}
        />
      </Form.Item>

      <Row gutter={30}>
        <Col span={12}>
          <Form.Item className='mb-2' label={<span className='text-gray'>City{requiredMark}</span>} {...errorProps(field('city'))}>
            <Input
              name={field('city')}
              placeholder='e.g. Fayetteville'
              value={locationDetail?.[field('city')]}
              onChange={changeValue}
              maxLength={100}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item className='mb-2' label={<span className='text-gray'>State/Province{requiredMark}</span>} {...errorProps(field('state'))}>
            <Input
              name={field('state')}
              placeholder='e.g. GA'
              value={locationDetail?.[field('state')]}
              onChange={changeValue}
              maxLength={100}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col span={12}>
          <Form.Item className='mb-2' label={<span className='text-gray'>ZIP/Postal Code{requiredMark}</span>} {...errorProps(field('zip'))}>
            <Input
              name={field('zip')}
              placeholder='e.g. 30214'
              value={locationDetail?.[field('zip')]}
              onChange={changeValue}
              maxLength={20}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item className='mb-2' label={<span className='text-gray'>Country{requiredMark}</span>} {...errorProps(field('country'))}>
            <Input
              name={field('country')}
              placeholder='e.g. US'
              value={locationDetail?.[field('country')]}
              onChange={changeValue}
              maxLength={2}
            />
          </Form.Item>
        </Col>
      </Row>

      {showFreightDirectLink && (
        <div className='mb-2'>
          <a href='https://www.fedexfreight.com/en-us/services/freight-direct' target='_blank' rel='noreferrer'>
            What is Freight Direct?
          </a>
        </div>
      )}

      <Form.Item className='mb-2'>
        <Radio.Group
          value={testType}
          onChange={e => changeValue({ target: { name: field('test_type'), value: e.target.value } })}
        >
          <Radio value='shipper'>Test FedEx Freight Account Number</Radio>
          <Radio value='thirdParty'>Test Third-party FedEx Freight Account Number</Radio>
        </Radio.Group>
      </Form.Item>
    </Col>
  )
}

export default FedexFreightAccountFieldset
